import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { AbstractValueAccessorComponent, ValueAccessorUtil, chipsValidator, trackBy } from '@railmybox/shared/util';

@Component({
  selector: 'eg-chips',
  templateUrl: './chips.component.html',
  styleUrl: './chips.component.scss',
  providers: [...ValueAccessorUtil.getValueAccessorProvider(ChipsComponent)],
  standalone: false,
})
export class ChipsComponent extends AbstractValueAccessorComponent<string[]> {
  emails: string[] = [];
  inputValue = '';
  trackBy = trackBy;
  showError = false;

  writeValue(value: string[] | string): void {
    if (!value) {
      this.emails = [];
      this.value = [];
      return;
    }

    if (Array.isArray(value)) {
      // Already an array → use it as-is
      this.emails = [...value];
    } else if (typeof value === 'string') {
      // It's a single string → split by spaces or commas
      this.emails = value.split(/[\s,]+/).filter((v) => v);
    } else {
      this.emails = [];
    }
    this.value = [...this.emails];
  }

  addEmail() {
    const raw = this.inputValue?.trim();
    if (!raw) return;

    const tempControl = { value: raw } as AbstractControl;
    const errors = chipsValidator(this.emails)(tempControl);

    if (errors) {
      this.showError = true;
      if (errors.invalid) {
        this.errorMessage = translate('forms.validation.chipEmailInvalid');
      } else if (errors.isInArray) {
        this.errorMessage = translate('forms.validation.chipEmailIsInArray');
      } else {
        this.errorMessage = translate('forms.validation.chipEmailInvalid');
      }
      return;
    } else {
      this.showError = false;
    }

    const normalized = raw.replace(/^<|>$/g, '');
    this.emails = [...this.emails, normalized];

    this.emitUserChange();

    this.inputValue = '';
    this.showError = false;
    this.errorMessage = null;
  }

  onKeydown(event: KeyboardEvent) {
    if (['Enter', ',', ';', ' '].includes(event.key)) {
      event.preventDefault();
      this.addEmail();
    }
  }

  onBlur() {
    this.markInputAsTouched();
    this.addEmail();
  }

  removeEmail(index: number) {
    if (index < 0 || index >= this.emails.length) return;

    this.emails.splice(index, 1);
    this.emitUserChange();

    this.formControl?.updateValueAndValidity();
  }

  private emitUserChange(): void {
    this.value = [...this.emails];
    this.onChange(this.value);
    this.changed.emit(this.value);
  }
}
